// Service for fetching distinct catalog attributes with pagination and search
import axiosInstance from "../axiosInstance";

export const catalogAttributesService = {
  /**
   * Fetch distinct attribute values from catalogs
   * @param {Object} filters - Filter options
   * @param {string} filters.key - Attribute key path (e.g., "products.page", "variants.sku")
   * @param {string} [filters.search] - Text search filter
   * @param {string} [filters.client_id] - Client ID filter
   * @param {string} [filters.catalog_uid] - Optional catalog edition uid filter
   * @param {number} [filters.page=1] - Page number (1-indexed)
   * @param {number} [filters.limit=10] - Items per page
   * @returns {Promise<Object>} { data, total, page, limit }
   */
  fetch: async (filters) => {
    try {
      const response = await axiosInstance.post("/catalog-attributes", filters);
      return response.data;
    } catch (error) {
      console.error("Error fetching catalog attributes:", error);
      throw error;
    }
  },
};
